import type { ArgoCDGatewayResource } from "@octopusdeploy/octopus-server-client";
import type { PageRouteDefinition, QueryParamValues, QueryParamValuesSetter, UnknownQueryParam } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { RnDTeam } from "~/RnDTeam";
import { pageAreas } from "~/routing/PageAreaContext";
import type { Loader } from "~/routing/pageRegistrations/Loader";
import type { LoadingContentRender, PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { StandardPageContext } from "~/routing/pageRegistrations/StandardPageContext";
import type { StandardLoaderContext } from "./StandardLoaderContext";
export function createLevel2ArgoCDInstancePageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: ArgoCDInstancePageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageId: string;
    owner: RnDTeam;
    loader?: Loader<LoaderData, ArgoCDInstancePageLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    helpContent?: () => ReactElement;
    helpTopics?: () => ReactElement;
    isFullWidth?: boolean;
}): PageRegistration<RouteParams, QueryParams, LoaderData, ArgoCDInstancePageLoaderContext, ArgoCDInstancePageContext> {
    return {
        route,
        render: config.render,
        pageId: config.pageId,
        owner: config.owner,
        pageArea: pageAreas.deploy.infrastructure,
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        helpContent: config.helpContent,
        helpTopics: config.helpTopics,
        level: 2,
        isFullWidth: config.isFullWidth ?? false,
    };
}
export interface ArgoCDInstancePageContext extends StandardPageContext {
    gateway: ArgoCDGatewayResource;
}
export interface ArgoCDInstancePageLoaderContext extends StandardLoaderContext {
    gateway: Promise<ArgoCDGatewayResource>;
}
